module.exports = __webpack_public_path__ + "static/media/imgEmojiEyes@3x.9f8f7b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imgEmojiEyes@3x.png
// module id = 363
// module chunks = 22